import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../../components/ui/select';

const ALL_MERCHANTS_VALUE = '__ALL__';

export type ReferralMerchantOption = {
  id: number;
  name: string;
};

type ReferralMerchantSelectProps = {
  merchants: ReferralMerchantOption[];
  value: string | null;
  onChange: (merchantName: string | null) => void;
  disabled?: boolean;
};

/**
 * Replaces the admin "Filters" panel entirely for a referral user — they're restricted to a
 * handful of assigned merchants (server-enforced, this is purely a UI convenience), so a plain
 * dropdown is a more direct way to switch between "all my merchants combined" and one at a time
 * than opening a checkbox-list filter drawer built for dozens of columns/values.
 */
export default function ReferralMerchantSelect({
  merchants,
  value,
  onChange,
  disabled,
}: ReferralMerchantSelectProps) {
  return (
    <Select
      value={value ?? ALL_MERCHANTS_VALUE}
      onValueChange={(next) => onChange(next === ALL_MERCHANTS_VALUE ? null : next)}
      disabled={disabled}
    >
      <SelectTrigger className="w-[220px]" aria-label="Filter by merchant">
        <SelectValue placeholder="All merchants" />
      </SelectTrigger>
      <SelectContent align="end">
        <SelectItem value={ALL_MERCHANTS_VALUE}>All merchants</SelectItem>
        {merchants.map((merchant) => (
          <SelectItem key={merchant.id} value={merchant.name}>
            {merchant.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
